// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1m3Kn","footer":"ModalCreateQualiphyProcedure_footer__3Pi-t","additionData":"ModalCreateQualiphyProcedure_additionData__2Ufjf"};